import {
  createEcommercePayload,
  CreateEcommercePayloadItemParams,
} from '@/features/gtm/internal/helper/create-ecommerce-payload';
import { emitGTMEvent } from '@/features/gtm/shared/helper/emit-gtm-event';

export type TrackAddToCartParams = CreateEcommercePayloadItemParams;

export function trackAddToCart(ecommerceParams: TrackAddToCartParams): void {
  const payload = createEcommercePayload(ecommerceParams);
  emitGTMEvent('ADD_TO_CART', payload);
}
